// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.page404[data-v-6b3aeb0e] {\n  text-align: center;\n  height: calc(100vh - 50px);\n  line-height: calc(100vh - 50px);\n}\n.page404 img[data-v-6b3aeb0e] {\n  width: 35%;\n  display: inline-block;\n  /* middle   把此元素放置在父元素的中部。 */\n  vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
